import { Loader2 } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FilterLoaderProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
  text?: string
}

export const FilterLoader = ({
  className,
  size = 'sm',
  showText = true,
  text = 'Loading...',
}: FilterLoaderProps) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-5 w-5',
    lg: 'h-6 w-6',
  }

  const textSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  }

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <Loader2
        className={cn('animate-spin text-muted-foreground', sizeClasses[size])}
      />
      {showText && (
        <span
          className={cn(
            'text-muted-foreground font-medium',
            textSizeClasses[size]
          )}
        >
          {text}
        </span>
      )}
    </div>
  )
}

export const FilterSkeleton = ({ className }: { className?: string }) => (
  <div className={cn('flex items-center gap-2', className)}>
    <div className='h-4 w-4 bg-muted animate-pulse rounded' />
    <div className='h-4 w-16 bg-muted animate-pulse rounded' />
  </div>
)
